import { render, staticRenderFns } from "./congratpage.vue?vue&type=template&id=3a70a601&scoped=true&"
import script from "./congratpage.vue?vue&type=script&lang=js&"
export * from "./congratpage.vue?vue&type=script&lang=js&"
import style0 from "./congratpage.vue?vue&type=style&index=0&id=3a70a601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70a601",
  null
  
)

export default component.exports